import { get } from 'svelte/store';
import { GameState, gameStates } from './machine/state-types';
import { allowToBet, gameRoundInfo } from '../store';
import { backend } from '../backend';
import { applyTopSlotToBonusGame, waitEnd, waitForBonusTransitionToFinish, waitForPlayClick } from './machine/helpers';

import { EventEmitterInstance } from '../utils/event-emitter';
import { cashReelsSelectedValue } from '../store/misc';
import { playAudio } from '../utils/audio';

export const state: GameState = {
    name: gameStates.cashReels,
    onEnter: async setState => {
        await waitForBonusTransitionToFinish();
        await applyTopSlotToBonusGame();

        await waitForPlayClick();
        allowToBet.set(false);

        const choice = get(cashReelsSelectedValue);
        const result = await backend.playBonus('CASH_REELS', choice);
        gameRoundInfo.set(result);

        EventEmitterInstance.emit('response-bonus-cash-reels', result);

        await waitEnd();

        if (result.final) setState(gameStates.bigWin);
        else {
            setState(gameStates.cashReelsDouble);
        }
    },
    onExit: () => {
        cashReelsSelectedValue.set(null);
    }
};
